import { DialogContent, Grid } from '@material-ui/core';
import { Button, ExpansionPanel, SidePanel, TextField, Typography } from '@nutrien/cxp-components';
import React from 'react';

import type { AssetsByAreaHeirachy } from '../../rxdb/assetsByAreaHeirachy/assetsByAreaHierarchy.types';
import {
  SectionCmlattribute,
  SectionCmlattributeValue,
} from '../../rxdb/lineandSectionPropertiesDetails/queryBuilder';
import GenericSidePanelHeader from '../GenericSidePanelHeader';
import useStyles from './LineAndSectionSidePanel.styles';

export interface DeleteModalConfig {
  title: string;
  bodyText: string;
  cancelButtonText: string;
  deleteButtonText: string;
  maxHeight?: number;
}
interface Props extends React.ComponentPropsWithoutRef<'div'> {
  open: boolean;
  sectionCmlattribute: SectionCmlattribute;
  cubeArea: AssetsByAreaHeirachy;
  Closecallback: (data: boolean) => void;
}

const LineAndSectionSidePalnel: React.FC<Props> = ({
  open,
  sectionCmlattribute,
  cubeArea,
  Closecallback,
}: Props) => {
  const classes = useStyles();
  let cube: string;

  const panelClose = () => {
    Closecallback(false);
  };

  const ShowCube = (cubeId: number) => {
    const childItem = cubeArea?.children;
    for (const k in childItem) {
      if (childItem[k].id === cubeId) {
        cube = childItem[k].areaPcsId;
      } else {
        for (const item of childItem[k].children) {
          if (item.id === cubeId) {
            cube = item.areaPcsId;
          } else {
            for (const subChildItem of item.children) {
              if (subChildItem.id === cubeId) {
                cube = subChildItem.areaPcsId;
              }
            }
          }
        }
      }
    }

    return (
      <TextField
        disabled={true}
        noMinHeight
        name="Cube"
        size="small"
        placeholder={cube}
        className={classes.textFieldSection}
      />
    );
  };

  return (
    <SidePanel open={open} onClose={panelClose} transitionDuration={200} disableBackdropClick>
      <GenericSidePanelHeader title="CML" onClose={panelClose} />
      <DialogContent className={classes.dialogContent}>
        <ExpansionPanel
          title="cml"
          key="deficiency-details"
          data-cy="deficiency-details"
          TransitionProps={{ unmountOnExit: true }}
          expanded={true}
          panelContent={
            <Grid item xs={12}>
              <Grid item xs={12} className={classes.gridAlign}>
                <Typography className="textFieldText">
                  <span>Fitting</span>
                </Typography>
                <TextField
                  disabled={true}
                  noMinHeight
                  name="Fitting"
                  size="small"
                  placeholder={sectionCmlattribute.fitting}
                  className={classes.textFieldSection}
                />
              </Grid>
              <Grid item xs={12} className={classes.gridAlign}>
                <Typography className="textFieldText">
                  <span>Surface</span>
                </Typography>
                <TextField
                  disabled={true}
                  noMinHeight
                  name="surface"
                  size="small"
                  placeholder={sectionCmlattribute.surface}
                  className={classes.textFieldSection}
                />
              </Grid>
            </Grid>
          }
        />
        <ExpansionPanel
          title="UT Measurement"
          key="deficiency-details"
          data-cy="deficiency-details"
          TransitionProps={{ unmountOnExit: true }}
          expanded={true}
          panelContent={
            <Grid item xs={12}>
              {sectionCmlattribute.sectionCmlattributeValue?.map(
                (item: SectionCmlattributeValue) => (
                  <>
                    {item.at3 || item.at6 || item.at9 || item.at12 ? (
                      <>
                        <Grid item xs={12} className={classes.gridAlign}>
                          <Typography className="textFieldText">
                            <span>@3</span>
                          </Typography>
                          <TextField
                            disabled={true}
                            noMinHeight
                            name="@3"
                            size="small"
                            placeholder={item.at3?.toString()}
                            className={classes.textFieldSection}
                          />
                        </Grid>
                        <Grid item xs={12} className={classes.gridAlign}>
                          <Typography className="textFieldText">
                            <span>@6</span>
                          </Typography>
                          <TextField
                            disabled={true}
                            noMinHeight
                            name="@6"
                            size="small"
                            placeholder={item.at6?.toString()}
                            className={classes.textFieldSection}
                          />
                        </Grid>
                        <Grid item xs={12} className={classes.gridAlign}>
                          <Typography className="textFieldText">
                            <span>@9</span>
                          </Typography>
                          <TextField
                            disabled={true}
                            noMinHeight
                            name="@9"
                            size="small"
                            placeholder={item.at9?.toString()}
                            className={classes.textFieldSection}
                          />
                        </Grid>
                        <Grid item xs={12} className={classes.gridAlign}>
                          <Typography className="textFieldText">
                            <span>@12</span>
                          </Typography>
                          <TextField
                            disabled={true}
                            noMinHeight
                            name="@12"
                            size="small"
                            placeholder={item.at12?.toString()}
                            className={classes.textFieldSection}
                          />
                        </Grid>
                      </>
                    ) : (
                      <Grid item xs={12} className={classes.gridAlign}>
                        <Typography className="textFieldText">
                          <span>UT Measurement</span>
                        </Typography>
                        <TextField
                          disabled={true}
                          noMinHeight
                          name="ut Measurement"
                          size="small"
                          placeholder={item.utMeasurement?.toString()}
                          className={classes.textFieldSection}
                        />
                      </Grid>
                    )}
                  </>
                ),
              )}
            </Grid>
          }
        />
        <ExpansionPanel
          title="Reference Measurement"
          key="reference-measurement"
          TransitionProps={{ unmountOnExit: true }}
          expanded
          panelContent={
            <Grid item xs={12}>
              <Grid item xs={12} className={classes.gridAlign}>
                <Typography className="textFieldText">Reference Measurement</Typography>
                <TextField
                  disabled
                  noMinHeight
                  name="Reference Measurement"
                  size="small"
                  placeholder={sectionCmlattribute?.refMeasurment}
                  className={classes.textFieldSection}
                />
              </Grid>
            </Grid>
          }
        />

        <ExpansionPanel
          title="cml"
          key="deficiency-details"
          data-cy="deficiency-details"
          TransitionProps={{ unmountOnExit: true }}
          expanded={true}
          panelContent={
            <Grid item xs={12}>
              <Grid item xs={12} className={classes.gridAlign}>
                <Typography className="textFieldText">
                  <span>Alarm(%)</span>
                </Typography>
                <TextField
                  disabled={true}
                  noMinHeight
                  name="Alarm"
                  size="small"
                  placeholder={sectionCmlattribute.alarm?.toString()}
                  className={classes.textFieldSection}
                />
              </Grid>
              <Grid item xs={12} className={classes.gridAlign}>
                <Typography className="textFieldText">
                  <span>Entered by</span>
                </Typography>
                <TextField
                  disabled={true}
                  noMinHeight
                  name="Entered by"
                  size="small"
                  placeholder={sectionCmlattribute.readingUser}
                  className={classes.textFieldSection}
                />
              </Grid>
              <Grid item xs={12} className={classes.gridAlign}>
                <Typography className="textFieldText">
                  <span>Reading Date</span>
                </Typography>
                <TextField
                  disabled={true}
                  noMinHeight
                  name="Reading Date"
                  size="small"
                  placeholder={sectionCmlattribute.dateReading?.substring(0, 10)}
                  className={classes.textFieldSection}
                />
              </Grid>
              <Grid item xs={12} className={classes.gridAlign}>
                <Typography className="textFieldText">
                  <span>Cube</span>
                </Typography>
                {ShowCube(sectionCmlattribute.cubeId)}
              </Grid>
              <Grid item xs={12} className={classes.gridAlign}>
                <Typography className="textFieldText">
                  <span>Access</span>
                </Typography>
                <TextField
                  disabled={true}
                  noMinHeight
                  name="Access"
                  size="small"
                  placeholder={sectionCmlattribute.access}
                  className={classes.textFieldSection}
                />
              </Grid>
            </Grid>
          }
        />
        <Grid className={classes.rightAlign}>
          <Button
            onClick={panelClose}
            variant="contained"
            color="primary"
            noMinHeight
            data-testid="close-side-panel"
          >
            Close
          </Button>
        </Grid>
      </DialogContent>
    </SidePanel>
  );
};

export default LineAndSectionSidePalnel;
